// extracted by mini-css-extract-plugin
export default {"right":"CaseFormSidebar_right__voTk0"};